import { buildWindowScript, chartAdvice } from '../../../platform/tradingview';
import config from '../config';

// This mode's settlement window, for the TradingView check. A run asked inside
// the session is priced from that moment to the same minute a session later;
// any other run from the start session's close to the end session's close.
export const chartWindow = batch => (batch.price_basis === 'minute_window'
  ? { start: batch.prediction_time, end: batch.target_close, intraday: true }
  : { start: { date: batch.start_date, hour: 16, minute: 0 }, end: batch.target_close });

// What SymbolChart needs for each ticker on a prediction's page.
export function chartFor(batch, prices = []) {
  const span = chartWindow(batch);
  return {
    advice: chartAdvice(span),
    build: symbol => () => {
      const p = prices.find(x => x.symbol === symbol);
      return buildWindowScript({
        symbol, window: span,
        recorded: { start: p?.start_close, end: p?.end_close },
        title: `${config.title} · ${batch.horizon}`,
        url: globalThis.location?.href || '',
      });
    },
  };
}
